export default __webpack_public_path__ + "static/media/image1.0b188216.jpg";